import React from 'react';
import { HeadlineTitle } from '../../components/Title';
import { SectionLayout } from '../../components/Layouts';
import { Row, Col } from '../../components/Grid';
import Button from '../../components/Button';
import * as T from '../../components/Typography';
import { PostsContentContainer } from '../../templates/style';

const Layout = ({ title, darkBG, children }) => {
  return (
    <SectionLayout bgcolor={darkBG ? 'midnight' : undefined}>
      <Row>
        <Col w={[4, 3, 4]}>
          <HeadlineTitle color={darkBG ? 'white' : 'midnight'}>{title}</HeadlineTitle>
        </Col>
        <Col w={[4, 3, 8]} mtM={3}>
          {children}
        </Col>
      </Row>
    </SectionLayout>
  );
};

const AboutTC = ({ title, boldParagraph, lightParagraph, to, darkBG, welsh, buttonText }) => {
  let text = buttonText;
  if (welsh) {
    text = text || 'Darllenwch Fwy';
  } else {
    text = text || 'Read more';
  }
  return (
    <Layout title={title} darkBG={darkBG}>
      <T.P16Bold color={darkBG ? 'white' : 'midnight'} as="pre" d="block">
        {boldParagraph}
      </T.P16Bold>
      <T.P16 color={darkBG ? 'white' : 'midnight'} mt={4} mtT={3} mtM={2} as="pre" d="block">
        {lightParagraph}
      </T.P16>
      {to && (
        <Row inner mt={4} mtT={3}>
          <Col w={[4, 6, 6]}>
            <Button
              to={to}
              color={darkBG ? 'white' : 'blue'}
              textColor={darkBG ? 'midnight' : 'white'}
              small
            >
              {text}
            </Button>
          </Col>
        </Row>
      )}
    </Layout>
  );
};

const AboutTCMarkDown = ({ title, content, darkBG }) => {
  return (
    <Layout title={title} darkBG={darkBG}>
      {content && (
        <PostsContentContainer
          color={darkBG ? 'white' : 'midnight'}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      )}
    </Layout>
  );
};

export { AboutTCMarkDown };
export default AboutTC;
